import React from "react";
import { IdcardOutlined } from "@ant-design/icons";
import { Tag } from "antd";

export default function TWIC({ key }) {
  return (
    <Tag key={key} color="purple" style={{ marginLeft: 5, fontWeight: "bold" }} icon={<IdcardOutlined />}>
      TWIC
    </Tag>
  );
}
